import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, ListItemIcon, ListItemText, Theme } from "@mui/material";
import { SxProps } from '@mui/system';
import React from "react";
import { IOrganization } from "../../../services/organization-data-service/Models";


import ListItemButton from "@mui/material/ListItemButton";


type MobileOrganizationListItemProps =  {
    data: IOrganization,
    open: boolean;
    onToggle: (item: IOrganization) => Promise<void>;
    onSelected: (item: IOrganization) => Promise<void>;
    sx?: SxProps<Theme>
};

export function MobileOrganizationListItem({data, open, onToggle, onSelected, sx}: MobileOrganizationListItemProps) {
    const onIconClick = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: IOrganization) => {
        event.persist();        
        event.stopPropagation();
        event.preventDefault();

        await onToggle(item);
    }

    const onItemClick = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>, item: IOrganization) => {

        event.persist();        
        event.stopPropagation();
        event.preventDefault();

        await onSelected(item);
    }

    return (
        <ListItemButton
            sx={sx}
            onClick={(e) => onItemClick(e, data)}
            role='treeitem'
            aria-expanded={open ? 'true' : 'false'}>
            <ListItemText>
                <Box 
                sx={{
                    whiteSpace: 'nowrap',  
                    overflow: 'hidden',  
                    textOverflow: 'ellipsis'
                }}>
                    {data?.displayText}
                </Box>                            
            </ListItemText>
            {
                (data?.children?.length ?? 0) > 0 &&
                <ListItemIcon style={{justifyContent: 'flex-end'}} onClick={(e) => onIconClick(e, data)} role='button' aria-label='expand or collapse'>
                    {!open ? <ExpandMore /> : <ExpandLess />}
                </ListItemIcon>
            }
        </ListItemButton>
    );
}

